
import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons'

import VoucherEntity from '@/lib/entities/voucher'
import numberMask from '~/lib/input-masks/number'

export default {
  name: 'FormDiscount',

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      numberMask,
      faArrowRightLong
    }
  },

  computed: {
    compModel: {
      // Don't use v-model with a vuex store
      set(newValue) {
        this.$emit('input', newValue)
      },

      get() {
        return this.value
      }
    },

    compValidations() {
      return new VoucherEntity().validation
    },

    compValuePrefix() {
      return this.compModel.type === 'PERCENTAGE' ? '%' : '£'
    }
  },

  created() {
    this.compModel = new VoucherEntity({ ...this.value }).model

    this.$store.dispatch('paddocks/fetchAll')
  }
}
